import { render, staticRenderFns } from "./ZenerDiodeViz.vue?vue&type=template&id=06a46aa0&scoped=true"
import script from "./ZenerDiodeViz.vue?vue&type=script&lang=js"
export * from "./ZenerDiodeViz.vue?vue&type=script&lang=js"
import style0 from "./ZenerDiodeViz.vue?vue&type=style&index=0&id=06a46aa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a46aa0",
  null
  
)

export default component.exports